// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"3308a87e","458":"b9682b03","608":"db96244c","613":"254b6fe7","707":"db96244c","730":"db96244c"}[chunkId] + ".chunk.css";
};